const notificationSupportedRoutes = [

	{
		route: {
			path: '/jobs/:title(.*W0QQAdIdZ)+:id',
			exact: true
		},
		notification: {
			context: 'vap',
			customPopup: true,
			customText: 'Would you like to receive notifications about latest jobs from Quikr? Subscribe and get',
			vertical: 'jobs',
			withTimeout: 5
		}
	},
	{
		route: {
			path: '/jobs/:query+(zwqxj)+:identifier',
			exact: true
		},
		notification: {
			context: 'snb',
			customPopup: true,
			customText: 'Would you like to receive notifications about latest jobs from Quikr? Subscribe and get',
			vertical: 'jobs',
			withTimeout: 5
		}
	},
	{
		route: {
			path: '/homes/pg/:slug(.*paying-guest+.*)',
			exact: true
		},
		notification: {
			context: 'homepage',
			customPopup: true,
			customText: 'Would you like to receive personalized notifications from Quikr? Subscribe and get',
			vertical: 'qhmr',
			withTimeout: 5
		}
	},
	{
		route: {
			path: '/:type(cars)/:slug(.*AdIdZ[\\d]+)',
			exact: true
		},
		notification: {
			context: 'vap',
			customPopup: true,
			customText: 'Would you like to receive notifications about matching cars from Quikr? Subscribe and get',
			vertical: 'cars',
			withTimeout: 5
		}
	},
	{
		route: {
			path: '/:type(cars-bikes|bikes-scooters)/:slug(.*AdIdZ[\\d]+)',
			exact: true
		},
		notification: {
			context: 'vap',
			customPopup: true,
			customText: 'Would you like to receive notifications about matching vehicles from Quikr? Subscribe and get',
			vertical: 'cars',
			withTimeout: 5
		}
	},
	{
		route: {
			path: '/:type(cars)/:slug(.*[w|x|y|z][\\d].*)',
			exact: true
		},
		notification: {
			context: 'snb',
			customPopup: true,
			customText: 'Would you like to receive notifications about matching cars from Quikr? Subscribe and get',
			vertical: 'cars',
			withTimeout: 5
		}
	},
	{
		route: {
			path: '/:type(cars-bikes)/:slug(.*[w|x|y|z][\\d].*)',
			exact: true
		},
		notification: {
			context: 'snb',
			customPopup: true,
			customText: 'Would you like to receive notifications about matching vehicles from Quikr? Subscribe and get',
			vertical: 'cars',
			withTimeout: 5
		}
	},
	{
		route: {
			path: '/:type(bikes-scooters)/:slug(.*[w|x|y|z][\\d].*)',
			exact: true
		},
		notification: {
			context: 'snb',
			customPopup: true,
			customText: 'Would you like to receive notifications about matching bikes/scooters from Quikr? Subscribe and get',
			vertical: 'cars',
			withTimeout: 5
		}
	},
	{
		route: {
			path: '/:type(home-lifestyle|electronics-appliances|mobiles-tablets)/:slug(.*W0QQAdIdZ[\\d]+)',
			exact: true
		},
		notification: {
			context: 'vap',
			customPopup: true,
			customText: 'Would you like to receive notifications about matching products from Quikr? Subscribe and get',
			vertical: 'bazaar',
			withTimeout: 5
		}
	},
	{
		route: { path: '/:type(home-lifestyle|electronics-appliances|mobiles-tablets)/:slug(.*[w|x|y|z][\\d]+f.*)', exact: true },
		notification: {
			context: 'snb',
			customPopup: false,
			customText: 'Would you like to receive notifications about matching products from Quikr? Subscribe and get',
			vertical: 'bazaar',
			withTimeout: 5
		}
	},
	{
		route: {
			path: '/:vertical(pets|matrimonial|community|entertainment|events)/:slug([0-9a-zA-z+-.]+-[a-zA-Z]+-W0QQAdIdZ[0-9]+)',
			exact: true
		},
		notification: {
			context: 'vap',
			customPopup: true,
			customText: 'Would you like to receive notifications and updates from Quikr? Subscribe and get',
			vertical: 'core',
			withTimeout: 5
		}
	},
	{
		route: {
			path: ':slug(.*qc[a-z]{2}0s.*)'
		},
		notification: {
			context: 'snb',
			customPopup: true,
			customText: 'Would you like to receive notifications and updates from Quikr? Subscribe and get',
			vertical: 'core',
			withTimeout: 5
		}
	}
];

export default notificationSupportedRoutes;


// WEBPACK FOOTER //
// ../q-components/components/notificationPopup/notificationSupportedRoutes.js